
import React from "react";
import PropTypes from "prop-types";
import { mainTable } from "../css/Common";

const RadioGroupTable = (props) => {
    const {
        title,
        name,
        options,
        selectedOption,
        controlFunc,
        disabled,
        tabIndex,
        errorMessage,
        classDiv,
        classLabel,
        classStar,
        Class1,
        Class,
        controlFuncBlur,
    } = props;

    const handleOptionChange = (value) => {
        if (controlFunc) {
            controlFunc(value);
        }
    };

    return (
        <div className={classDiv || "form-group"}>
            {title && (
                <label className={classLabel || mainTable.label}>
                    {title}
                    <span className={classStar || "hidden"}>*</span>
                </label>
            )}

            <div className={Class1 || mainTable.inputRadioDiv}>
                {options.map((option) => (
                    <label
                        key={option.value}
                        className={classLabel || mainTable.inputRadioLabel}
                    >
                        <input
                            type="radio"
                            className={Class || mainTable.inputRadio}
                            name={name}
                            value={option.value}
                            checked={
                                Number(selectedOption) === Number(option.value)
                            }
                            onChange={() =>
                                handleOptionChange(Number(option.value))
                            }
                            disabled={disabled}
                            tabIndex={tabIndex}
                            onBlur={controlFuncBlur}
                        />
                        {option.label}
                    </label>
                ))}
            </div>

            {errorMessage && (
                <span className="text-red-500">{errorMessage}</span>
            )}
        </div>
    );
};

RadioGroupTable.propTypes = {
    title: PropTypes.string,
    name: PropTypes.string.isRequired,        // ✅ REQUIRED
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number,
            ]).isRequired,
            label: PropTypes.string.isRequired,
        })
    ).isRequired,
    selectedOption: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    controlFunc: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    tabIndex: PropTypes.string,
    errorMessage: PropTypes.string,
};

export default RadioGroupTable;